<template>
  <div>
    <div class="toph mb16" >
      <span>待办商机</span>
      <span style="display: flex; align-items: center">
        <Input style="width: 300px ;" v-model="searchData.customerInfo" placeholder="请输入客户姓名或电话，回车搜索" @keyup.enter.native="inputChange" clearable></Input>
        <label @click.stop="inputChange" style="display: flex; margin-left: 5px">
          <Icon type="ios-search" size="24" color="#CFA868"/>
        </label>
      </span>

    </div>
    <div>
      <Tabs v-model="shortCut1" class="toph-tabs">
        <TabPane :label="'待跟进'+' '+dgjNum" name="dgj"></TabPane>
        <TabPane :label="'跟进中'+' '+gjzNum" name="gjz"></TabPane>
        <TabPane :label="'待带看'+' '+ddkNum" name="ddk"></TabPane>
        <TabPane :label="'待回访'+' '+dhfNum" name="dhf"></TabPane>
      </Tabs>


      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading" :total="total"
        :current="current" @change-page="changePage"
        :pageSize="5"
        :defaultTem="isShow"
      >
      </table-list>

      <a @click="go" style="position: relative; top: -15px;left: 24px" v-p="{api:'business/list'}">查看全部商机</a>
      <read-or-handle-modal
        :uid="uid"
        :n="readOrHandleKey"
        :zoFid="zoFid"
        :businessFid = "businessFid"
        :projectFid="detailProjectFid"
        :statusList = "statusList"
        @refresh="findData"
        :isRead="isRead"
        :budgetRangeList="budgetRangeList"
        :commutingModeList="commutingModeList"
        :intentionAreaList="intentionAreaList"
        :houseTypeList="houseTypeList"
        :liveNumberList="liveNumberList"
        :placeList="placeList"
        :rentTypeList="rentTypeList"
        :rentTimeList="rentTimeList"
        :enumList="enumList"
        :gradeList="gradeList"
      >
      </read-or-handle-modal>
      <check-personas
      :uid="uid"
      :n="checkPersonasKey"
      ></check-personas>
      <update-personas
      :n="updatePersonasKey"
      :uid="uid"
      :projectFid="projectFid"
      ></update-personas>
    </div>

  </div>
</template>

<script>
  import TableList from 'components/TableList/index'
  import {getBusinessNum, allowHandleBusiness,getBusinessEnums} from 'api/business'
  import { getList} from 'api/business'
  import {formatDateTime} from "@//utils/format"
  import { getSelectedData } from 'api/business'
  import ReadOrHandleModal from '../../business/readBusiness/components/ReadOrHandle'
  import UpdatePersonas from '../../business/infoManage/components/UpdatePersonas'
  import CheckPersonas from '../../business/infoManage/components/CheckPersonas'
  export default {
    name: "Bussiness",
    components: {
      TableList,
      ReadOrHandleModal,
      UpdatePersonas,
      CheckPersonas
    },
    watch:{
      projectFid(){
        this.recordCut = ''
        this.searchData.customerInfo = ''
        this.page=1
        this.current=1
        this.getBusinessNum()
      },
      shortCut1(value){
        switch (value) {
          case 'dgj':
            this.clearValue()
            this.searchData.handleStatus = 0;
            break;
          case 'gjz':
            this.clearValue()
            this.searchData.handleStatus = 1;
            break;
          case "ddk":
            this.clearValue()
            this.searchData.handleStatus = 2;
            break;
          case 'dhf':
            this.clearValue()
            this.searchData.handleStatus = 3;
            break;
        }
        this.page=1
        this.current=1
        this.data = []
        this.total = 0
        this.getpageList();
      }
    },
    computed:{
      othersColumns () {
        if(this.shortCut1=='dgj'){
          return [{
            title: '截止处理时间',
            key: 'keyTip',
            align: 'center',
            width:180
          },{
            title:' ',
          }]
        } else if(this.shortCut1=='gjz'){
          return [{
            title: '进一步跟进时间',
            key: 'endHandleTime',
            align: 'center',
            width:180,
            render: (h,params) => {
              return h('div',formatDateTime(params.row.endHandleTime, true).slice(0, 16))
            }
          },{
            title:' ',
          },{
            title: '最新跟进内容',
            key: 'handleRecord',
            width:150,
            align: 'center',
            render: (h, params) => {
              if (params.row['handleRecord'] && params.row['handleRecord'].length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['handleRecord']),
                  h('span', {}, params.row['handleRecord'].slice(0, 7) + '...')
                ])
              }
              else {
                return h('span', {}, params.row['handleRecord'])
              }
            }
          },{
            title:' ',
          }]
        } else if(this.shortCut1=='ddk'){
          return [{
            title: '预计带看时间',
            key: 'endHandleTime',
            align: 'center',
            width:180,
            render: (h,params) => {
              return h('div',formatDateTime(params.row.endHandleTime, true).slice(0, 16))
            }
          },{
            title:' ',
          },{
            title: '最新跟进内容',
            key: 'handleRecord',
            width:150,
            align: 'center',
            render: (h, params) => {
              if (params.row['handleRecord'] && params.row['handleRecord'].length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['handleRecord']),
                  h('span', {}, params.row['handleRecord'].slice(0, 7) + '...')
                ])
              }
              else {
                return h('span', {}, params.row['handleRecord'])
              }
            }
          },{
            title:' ',
          }]
        } else if(this.shortCut1=='dhf'){
          return [{
            title: '预计回访时间',
            key: 'endHandleTime',
            align: 'center',
            width:180,
            render: (h,params) => {
              return h('div',formatDateTime(params.row.endHandleTime, true).slice(0, 16))
            }
          },{
            title:' ',
          },{
            title: '最新跟进内容',
            key: 'handleRecord',
            width:150,
            align: 'center',
            render: (h, params) => {
              if (params.row['handleRecord'] && params.row['handleRecord'].length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['handleRecord']),
                  h('span', {}, params.row['handleRecord'].slice(0, 7) + '...')
                ])
              }
              else {
                return h('span', {}, params.row['handleRecord'])
              }
            }
          },{
            title:' ',
          }]
        }
      },
      gradeColumn () {
        return this.shortCut1 !== 'dgj' ? [{
            title:' ',
          },
          {
            title: '商机等级',
            key: 'grade',
            align: 'center',
            width:150
          },] : []
      },
      columns(){
        return [

          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {
            title:' ',
          },
          {
            title: '姓名',
            key: 'customerName',
            width:100,
            align: 'center'
          },
          {
            title:' ',
          },
          {
            title: '电话',
            key: 'customerPhone',
            align: 'center',
            width:120
          },
          {
            title:' ',
          },
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            width:150
          },
          ...this.gradeColumn,
          {
            title:' ',
          },
          ...this.othersColumns,
          {
            title: '来源平台',
            key: 'businessFromPlatform',
            align: 'center',
            width:100,
            render: (h,params) => {
              return h('div',this.getPlatStr(params.row.businessFromPlatform))
            }
          },
          {
            title:' ',
          },
          {
            title: '来源渠道',
            key: 'businessFromChannel',
            width:100,
            align: 'center',
            render: (h,params) => {
              return h('div',this.getChannelStr(params.row.businessFromChannel))
            }
          },
          {
            title:' ',
          },
          {
            title: '渠道人信息',
            key: 'superZoBusinessChannelInfo',
            width:200,
            align: 'center',
            render: (h,params) => {
              if(params.row.channelCode){
                return h('div',params.row.channelPhone + '-' + params.row.channelName + params.row.channelCode)
              }
            }
          },
          {
            title:' ',
          },
          {
            title: 'ZO',
            key: 'zoName',
            width:90,
            align: 'center'
          },
          {
            title:' ',
          },
          {
            title: '操作',
            key: 'action',
            width:250,
            fixed:'right',
            align: 'center',
            render: (h,params)=>{
              return h('div',[h('a',{
                style: {
                  marginRight: '5px'
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/getDetail'
                    }
                  }
                ],
                on:{
                  click: () => {
                    this.isRead = true
                    this.readOrHandleKey++;
                    this.businessFid = params.row.businessFid
                    this.detailProjectFid = params.row.projectFid
                  }
                }
              },'跟进记录'),h('a',{
                style: {
                  marginRight: '5px',
                  display: params.row.handleStatus==4 || params.row.handleStatus == 5 || params.row.handleStatus ==6 ? 'none' :'inline-block'
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/saveBusinessHandle'
                    }
                  }
                ],
                on:{
                  click: () => {
                    allowHandleBusiness(params.row.businessFid).then( res => {
                      if(res.data==='true') {
                        this.isRead = false
                        this.businessFid = params.row.businessFid
                        this.detailProjectFid = params.row.projectFid
                        this.zoFid = params.row.zoFid
                        this.uid= params.row.customerUid
                        if(this.shortCut1 === 'dgj'){
                          this.recordCut = 'dgj'
                        }else if(this.shortCut1 === 'gjz'){
                          this.recordCut = 'gjz'
                        }else if(this.shortCut1 === 'ddk'){
                          this.recordCut = 'ddk'
                        }else if(this.shortCut1 === 'dhf'){
                          this.recordCut = 'dhf'
                        }
                        this.readOrHandleKey++;
                      }else {
                        this.$Message.error('您没有修改该条商机的权限')
                      }
                    })
                  }
                }
              },'处理'),
                h('a',{
                style: {
                  marginRight: '5px',
                  display:params.row.customerUid ? 'inline-block' :'none'

                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/updateCustomer'
                    }
                  }
                ],
                on:{
                  click:()=>{
										this.projectFid = params.row.projectFid;
                    this.uid = params.row.customerUid;
                    this.updatePersonasKey++
                  }
                }
              },'更新画像'),h('a',{
                style: {
                  marginRight: '5px',
                  display:params.row.customerUid ? 'inline-block' :'none'

                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/getCustomerPortrait'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.uid = params.row.customerUid;
                    this.checkPersonasKey++;
                  }
                }
              },'查看画像')
              ])
            }
          },
          {
            title:' ',
          },
        ]
      }
    },
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        enumList:null,
        checkPersonasKey:0,
        updatePersonasKey:0,
        uid:'',
        recordCut:'',
        shortCut1: 'dgj',
        sourceList:[],
        channelList:[],
        gradeList: [],
        page: 1,
        limit: 5,
        searchData: {
          customerInfo:'',
          source:1,//请求来源1-工作台
          handleStatus: 0,
        },
        dgjNum: 0,
        gjzNum: 0,
        ddkNum: 0,
        dhfNum: 0,
        data:[],
        total:0,
        loading:false,
        current: 1,
        readOrHandleKey:0,
        isRead:false,
        businessFid:'',
        detailProjectFid:'',
        zoFid:'',
        statusList:[],
        isShow:false,
        budgetRangeList:[],
        clientTypeList:[],
        commutingModeList:[],
        intentionAreaList:[],
        houseTypeList:[],
        liveNumberList:[],
        placeList:[],
        rentTypeList:[],
        rentTimeList:[],
      }
    },
    methods: {
      findData(){
        if (this.data.length === 1) {
          this.page=1
          this.current=1
        }
        this.getBusinessNum()
        this.$emit('refreshTotalNum')
      },
      changePage(n) {
        this.current = n
        this.page = n
        this.getpageList()
      },
      getpageList() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          page:this.page,
          limit: 5,
          ...this.searchData
        }
        this.loading = true
        getList(params).then(res => {
          if(!res.data){
            return
          }
          this.data = res.data.rows
          if(this.data.length<=0 ) {
            this.isShow = true;
          }
          this.total = res.data.total
          this.loading = false
        }).catch(error => {
          this.loading = false
        })
      },
      getBusinessNum() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          customerInfo:this.searchData.customerInfo
        }
        getBusinessNum(params).then(res => {
          if(!res.data){
            return
          }
          res.data.forEach((ele)=>{
            if(ele.businessStatus == 0){
              this.dgjNum = ele.number
            }else if (ele.businessStatus == 1){
              this.gjzNum = ele.number
            }else if (ele.businessStatus == 2){
              this.ddkNum = ele.number
            }else if (ele.businessStatus == 3){
              this.dhfNum = ele.number
            }
          })
          this.locationTab()
          this.getpageList()
        }).catch(error => {
          const data = {
            "dgjNum": 0,
            "gjzNum": 0,
            "ddkNum": 0,
            "dhfNum": 0,
          }
          this.dgjNum = data.dgjNum
          this.gjzNum = data.gjzNum
          this.ddkNum = data.ddkNum
          this.dhfNum = data.dhfNum
        })
      },
      clearValue() {
        this.page = 1
        this.limit = 5
      },
      inputChange(){
        this.current=1
        this.page=1
        this.data=[]

        if(this.shortCut1 === 'dgj'){
          this.recordCut = 'dgj'
        }else if(this.shortCut1 === 'gjz'){
          this.recordCut = 'gjz'
        }else if(this.shortCut1 === 'ddk'){
          this.recordCut = 'ddk'
        }else if(this.shortCut1 === 'dhf'){
          this.recordCut = 'dhf'
        }

        this.getBusinessNum()
      },
      getPlatStr(code){
        if (!this.sourceList.length) return ''
        const str = this.sourceList.find( item => {
          return item.value == code
        })
        return str?str.text:''
      },
      getChannelStr(code) {
        if (!this.channelList.length) return ''
        const str = this.channelList.find( item => {
          return item.value == code
        })
        return str?str.text:''
      },
      locationTab() {
        if(this.recordCut === 'dgj'){
          this.shortCut1='dgj'
          this.searchData.handleStatus = 0;
          return
        }else if(this.recordCut === 'gjz'){
          this.shortCut1='gjz'
          this.searchData.handleStatus = 1;
          return
        }else if(this.recordCut === 'ddk'){
          this.shortCut1='ddk'
          this.searchData.handleStatus = 2;
          return
        }else if(this.recordCut === 'dhf'){
          this.shortCut1='dhf'
          this.searchData.handleStatus = 3;
          return
        }

        if(this.dgjNum){
          this.shortCut1='dgj'
          this.searchData.handleStatus = 0;
        }else if(this.gjzNum){
          this.shortCut1='gjz'
          this.searchData.handleStatus = 1;
        }else if(this.ddkNum){
          this.shortCut1='ddk'
          this.searchData.handleStatus = 2;
        }else if(this.dhfNum){
          this.shortCut1='dhf'
          this.searchData.handleStatus = 3;
        }else {
          this.shortCut1='dgj'
          this.searchData.handleStatus = 0;
        }
      },
      formate(data){
        data.forEach(ele=>{
          ele['label']= ele.text
          if(ele.children){
            this.formate(ele.children)
          }
        })
      },

      initData(){
        this.getBusinessNum()
        getSelectedData().then( res => {
          this.sourceList = res.data.source
          this.channelList = res.data.channel
          this.gradeList = res.data.grade
          this.statusList = res.data.status
          this.formate(res.data.status)
          const index = this.statusList.findIndex(item => {
            return item.value == 0
          })
          if(index > -1) {
            this.statusList.splice(index,1)
          }
        })
      },
      getAllSelect(){
        getBusinessEnums().
        then( res => {
          if(!res.data){
            return

          }
          this.enumList=res.data
          this.budgetRangeList = res.data.budgetRange;
          this.commutingModeList = res.data.commutingMode;
          this.intentionAreaList = res.data.intentionArea;
          this.houseTypeList = res.data.houseType;
          const liveNumberList = res.data.liveNumber;
          for(let i = 1 ; i <= liveNumberList; i++){
            this.liveNumberList.push(i)
          }
          this.placeList = res.data.place;
          this.rentTypeList = res.data.rentType;
          this.rentTimeList = res.data.rentTime;
        })
      },
      go(){
        console.log('----')
        console.log(this.projectFid)
        this.$router.push({name : 'business',params:{projectFid:this.projectFid,customerInfo:this.searchData.customerInfo,targetTab:'sj'}})
      }
    },
    created() {
      this.initData()
      this.getAllSelect();
    }
  }
</script>

<style scoped>
  .toph{
    display: flex;
    background-color: #F4F4F4 ;
    box-shadow: 0 1px 0 0 #F4F4F4;
    justify-content: space-between;
    align-items: center;
    padding:0  20px ;
    box-sizing: border-box;
    line-height: 40px;
  }
</style>
<style>
.toph-tabs .ivu-tabs-bar{
  margin-bottom:0px;
}

</style>
